export default "__VITE_ASSET__B6__9CmO__"